import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { LoadingStateProps } from '../types';

const LoadingState: React.FC<LoadingStateProps> = ({ message, subtitle }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      height: '100%'
    }}>
      <CircularProgress size={60} sx={{ color: 'secondary.main', mb: 3 }} />
      <Typography variant="h6" color="text.secondary" sx={{ mb: subtitle ? 1 : 0 }}>
        {message}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingState;
